


class PrivatePathUpdate {
    constructor() {
    
 		/// global variables for muted and CC available everywhere
        window._muted =  false;
        window._CC = false;   
    
		this.setAudioPlayer = this.setAudioPlayer.bind(this);
		this.update = this.update.bind(this);
		this.stopAllVideo = this.stopAllVideo.bind(this);
		this.toggleAudio = this.toggleAudio.bind(this);
		this.muteAll = this.muteAll.bind(this);
		this.removeAllHighlighted = this.removeAllHighlighted.bind(this);
		this.keyUpEvent = this.keyUpEvent.bind(this);
		
		this._playr;
		this._current_tab_index;	
		
		let _this = this;
				
		/// on keyup remove all highlights and add any new one.		
		document.addEventListener( 'keyup', _this.removeAllHighlighted );
		
		/// check every half second to make sure the correct item is being highlighted
		this.chckHighlt = setInterval(_this.removeAllHighlighted, 500);
			
    }
    
    
    /// initialize all the audio players
  	setAudioPlayer( n ){
  	
  		/// the main closed caption elements on the top
    	this.closed_caption = n.querySelector('#closed_caption');
  	  	this.closed_caption_txt = this.closed_caption.querySelector('.text');  	
  	  	
  	  	
  	  	/// find all voice over elements and add closed captioning if available
  		var o = n.querySelectorAll(".vo_audio_elm");
  		o.forEach((aud) => {
		 	var _vtt = aud.textTracks[0];
				let _this = this;
			if(_vtt){
				_vtt.oncuechange = function(e) {														
					_this.closed_caption_txt.innerHTML = '';
					 var cue = this.activeCues[0];
					 if (cue) {
						_this.closed_caption_txt.appendChild(cue.getCueAsHTML());
					 }
				};
				aud.addEventListener("ended", function(e) {
					_this.closed_caption_txt.innerHTML = '';
				});					
			}

		});

		
  	}
  	
  	
  	/// remove any and all highlighted elements
  	removeAllHighlighted(){
		const o = document.querySelectorAll('.highlighed');
		o.forEach( elmnt => {
			if(document.activeElement != elmnt ) {
				elmnt.classList.remove('highlighed');
			}
			
		});  	
  	}

  	
  	/// global function to update (can add tracking here)
  	update(n){
  		if (typeof n === 'string' || n instanceof String) {
  					
			if( n == 'closeView' ){
				/// close button on view closed
				n = 'flying';






				this.closed_caption_txt.innerHTML = '';

				var sounds = document.getElementsByTagName('audio');
				for (i = 0; i < sounds.length; i++) sounds[i].pause();

				

				document.querySelector(".intro-content").classList.remove("hide_intro");

				//let views = document.querySelectorAll(".views .view");

				//for (var i = 0, len = views.length; i < len; i++) {
				//	views.classList.add("hidden");
				//}

			}
			
			/// change audio
			
			if(n=='takeoff'){
			
				/// audio specific to the beginning
				setTimeout(function(){
					let p = document.querySelector("#aud_tower");
					p.play();
				}, 1600);
				 
				
				let p2 =  document.querySelector("#aud_jet_takeoff");
				p2.play();

				
			} else {	 		 

				//var sounds = document.getElementsByTagName('audio');
				//for (i = 0; i < sounds.length; i++) sounds[i].pause();


				/// play any audio element with correct id

				if (this._playr !== document.querySelector("#aud_" + n)) {

						var sounds = document.getElementsByTagName('audio');
				for (i = 0; i < sounds.length; i++) sounds[i].pause();
				
					/// stop current player
					if(this._playr){
						this._playr.pause();
					} 
		
					this._playr = document.querySelector("#aud_" + n);
					
					//console.log(active_menu_item);


					if(this._playr){
					
						/// start the audio, check for delay attribute 
						let d = 0, _this = this;
						if(this._playr.getAttribute('delay')){
							d = this._playr.getAttribute('delay') * 1000;
						}
						
						/// settimeout delay (0 if no delay)

						setTimeout(function(){
							if (_this._playr) { 
								//console.log("audio found");
								_this._playr.currentTime = 0;
								_this._playr.play();						
							}
						}, d);
					}				
				}		 

			} 

			/// change tab order 
			 
			/// reset all elements to no taborder (unless its videojs)
			const elmntsWithTabindex = document.querySelectorAll('[tabindex], button, body');
			elmntsWithTabindex.forEach( elmnt => {
				if(elmnt.className.indexOf('vjs') < 0){
					//elmnt.tabIndex = -1;  

					var intro2 = document.getElementById("intro2");

					//if ((elmnt.classList.contains("cockpit_btn_audio")) || (elmnt.classList.contains("cockpit_btn_closedc")) ){
					//if  (elmnt.classList.contains("cockpit_btn_closedc")) ){

						

					//	if (intro2.classList.contains("hidden")) {
					//		//document.querySelector(".cockpit_btn_audio").setAttribute('tabindex', '3');
					//		document.querySelector(".cockpit_btn_closedc").setAttribute('tabindex', '3');
					//	} else {
					//		//document.querySelector(".cockpit_btn_audio").setAttribute('tabindex', '2');
					//		document.querySelector(".cockpit_btn_closedc").setAttribute('tabindex', '2');
     //                   }


					//}else {
					//	elmnt.tabIndex = -1; 
     //               }

					
					
					//elmnt.removeEventListener( 'keyup', this.keyUpEvent);					
				}  
			})			
			
			let o = [];
			
			/// arrays of tab elements specific to each view/popup

			
			let _nav_buttons = ['.cockpit_btn_menu', '.cockpit_btn_settings', '.cockpit_btn_summary', '.cockpit_btn_contact', '.cockpit_btn_instructions'];

				//console.log(n);
				

			switch(n){
				case "Intro1":
					o = ['#btn_intro_sequ_ok', '#btn_intro_sequ_next'];
					break; 

				case "Intro2":
					o = ['#btn_intro_sequ_start'];
					break;

				case "takeoff":
					o = [];
					break;
				
				case "flying":
					o = this.mergeArray(['.airplane-beacons-aboutPadcev', '.airplane-beacons-populationPost', '.airplane-beacons-populationCisplatin', '.airplane-beacons-dosingAdministration'], _nav_buttons);
					break;
				
				case "Menu":
					o = this.mergeArray(
							['#menu_btn_aboutPadcev',
							'#menu_btn_nccn',
							'#menu_btn_moa',
							'#menu_btn_moaVideo',
							'#menu_btn_populationPost',
							'#menu_btn_populationPatient',
							'#menu_btn_populationCisplatin',
							'#menu_btn_populationCisplatinPatient',
							'#menu_btn_populationCisplatinEfficacy',
							'#menu_btn_dosingAdministration',
							'#menu_btn_doseModifications'], _nav_buttons);

					document.body.classList.remove('hasOutro');
					break;


				case "aboutPadcev":
					o = this.mergeArray(['#close_btn_aboutPadcev', '#_tab_aboutPadcev_1', '#_tab_aboutPadcev_2', '#_tab_aboutPadcev_3', '#_tab_aboutPadcev_4'], _nav_buttons);
					break;

				case "populationPost":
					o = this.mergeArray(['#close_btn_populationPost', '#_tab_populationPost_1', '#_tab_populationPost_2'], _nav_buttons);
					break;

				case "populationCisplatin":
					o = this.mergeArray(['#close_btn_populationCisplatin', '#_tab_populationCisplatin_1', '#_tab_populationCisplatin_2', '#_tab_populationCisplatin_3'], _nav_buttons);
					break;

				case "dosingAdministration":
					o = this.mergeArray(['#close_btn_dosingAdministration', '#_tab_dosingAdministration_1', '#_tab_dosingAdministration_2'], _nav_buttons); 
					break;


				//case "unmetNeeds":				
				//	o = this.mergeArray(['#close_btn_unmetNeeds'], _nav_buttons); 
				//	break;

				//case "moa":		
				//	o = this.mergeArray(['#close_btn_moa', '#tab_moa_moa', '#tab_moa_video'], 	_nav_buttons);
				//	break;

				//case "moa-video":		
				//	o = this.mergeArray(['#close_btn_moa', '#tab_moa_moa', '#tab_moa_video'], 	_nav_buttons);
				//	break;

				//case "studyDesign":
				//	o = this.mergeArray(['#close_btn_studyDesign', '#tab_studydesign_study', '#tab_studydesign_char'], 	_nav_buttons);
				//	break;

				//case "dosingAndAdmin":	
				//	o = this.mergeArray(['#close_btn_dosingAndAdmin'], 	_nav_buttons);
				//	break;
				
				//case "overallSurvival":
				//	o = this.mergeArray(['#close_btn_overallSurvival'], _nav_buttons);
				//	break;
				
				//case "pfsOrr":
				//	o = this.mergeArray(['#close_btn_pfsOrr', '#tab_pfsorr_PFS', '#tab_pfsorr_ORR'], _nav_buttons);
				//	break;

				//case "qualityOfLife":
				//	o = this.mergeArray(['#close_btn_qualityOfLife'], _nav_buttons);
				//	break;

				//case "safety":		
				//	o = this.mergeArray(['#close_btn_safety'], _nav_buttons);
				//	break;
				
				case "Contact":	
					o = this.mergeArray(['#close_btn_contact'], _nav_buttons);
					break;
				
				case "FlightInstructions":	
					o = this.mergeArray(['#close_btn_Instructions'], _nav_buttons);
					break;

				//case "Settings":
				//	o = this.mergeArray(['.toggle'], _nav_buttons);
						
			}
			
			/// global tab order
			o.push('.isi_button');
			o.push('#pi_link');
						
				this._current_tab_index = o;

				//console.log(o);
			
			/// loop through all elements and assign tab order
				var _count = 1, _this = this;

				


			for(var i=0; i<o.length; ++i){
				let el = document.querySelector(o[i]);
				if(el){
					el.tabIndex = _count;
					el.addEventListener( 'keyup', this.keyUpEvent);					
					++_count;
				}
				}
				
  		}

  	}


	/// listen for key up for tabbing/ accesibility
	keyUpEvent(e){
	
		/// buttons will already trick on enter. Exit out to prevent double click

		if(e.target.type=='submit' &&  e.which == 13){
			return;
		}
		
		/// if enter or space key, trigger click

		if( e.which == 13 || e.which == 32 || e.code === "Space") {
			e.target.click();
			e.stopPropagation();
			e.preventDefault();							
			this.removeAllHighlighted();
		}
		if(document.activeElement == e.target ) {
			e.target.classList.add('highlighed');
		}	
	}
	
	
  	mergeArray(ar1, ar2){
  		let o = ar1.concat(ar2);
  		return o;
  	}
  	
  	/// stop video between screens
  	stopAllVideo (){ 
  		document.querySelectorAll("video:not(.airplane-takeoff-video)").forEach(elem => this.endPlaying(elem));
  	}
  	
  	/// reset audio to start on complete
	endPlaying( elm ){
		elm.pause();
		elm.currentTime = 0;  
	}  

	/// toggle mute audio
    toggleAudio() {
        window._muted = !window._muted;
        if (window._muted) {
            document.querySelectorAll("audio").forEach(elem => this.muteElm(elem));
            document.body.classList.add('muted');
        } else {
            document.querySelectorAll("audio").forEach(elem => this.unmuteElm(elem));
            document.body.classList.remove('muted');
        }
    }
    
    /// mute all audio
    muteAll(){
        document.body.classList.add('muted');   
        document.querySelectorAll("audio").forEach(elem => this.muteElm(elem));
        window._muted = true;   
    }

 	/// mute audio
    muteElm(elem) {
        elem.muted = false;
    }
    
    /// unmute audio
    unmuteElm(elem) {
        elem.muted = false;
    }
 	
  	
}


/// part of the singleton constructor
class PathUpdate {
    constructor() {
        throw new Error('Use PathUpdate.getInstance()');
    }
    static getInstance() {
        if (!PathUpdate.instance) {
            PathUpdate.instance = new PrivatePathUpdate();
        }
        return PathUpdate.instance;
    }
}
module.exports = PathUpdate;








